(function($) {
    
    "use strict";
    $.fn.infinitewalker = function(options) {
        
        var pref = "dnfw";
        var $menu = $(this);
        
        $menu.find("."+pref+"-dropdown-toggle").click(function(){

            var $m =  $(this).is("li") ? $(this).children(".dropdown-menu").first() : $(this).siblings(".dropdown-menu").first();
            
            if($m.hasClass(pref+"-open")){
                hideMenu($m, null);
            }
            else{
                hideAllMenus($m);
                showMenu($m, null);
            }
        });
        
        $(document).click(function(e){
            var $target = $(e.target);
            if(!isClickInMenu($target)){
                hideAllMenus(null, null);
            }
        });
        
        function isClickInMenu($target){   
            
            var menuTraIParent = $target.parents("#"+$menu.attr("id")).size() != 0;
            var isMenuItem = $target.hasClass('menu-item');
            var isInDropdownToggle = $target.hasClass(pref+'-dropdown-toggle') || $target.parents('.'+pref+'-dropdown-toggle') != 0;
            var isInDropdownMenu = $target.hasClass('dropdown-menu') || $target.parents('.dropdown-menu').size() != 0;

            var res = (menuTraIParent && (isMenuItem || isInDropdownToggle || isInDropdownMenu));

            return res;
        }
        
        /*
         * Chiudo tutti i menu aperti, ad eccezione del corrente e di tutti i suoi parenti
         */
        function hideAllMenus($except, callback){
            
            var $exceptList = Array();
            if($except != null){
                $exceptList = $except.parents(".dropdown-menu");
                $exceptList.push($except);
            }
            
            
            $(".dropdown-menu").each(function(){
                var shouldHide = true;
                for(var i=0; shouldHide==true && i<$exceptList.length; i++){
                    if($(this).is($exceptList[i])){
                        shouldHide = false;
                    }
                }
                if(shouldHide){
                    hideMenu($(this), null);
                }
            });
        }
        
        function showMenu($menu, callback){

            if($menu.hasClass(pref+"-open")){
                return;
            }
            
            $menu.addClass(pref+"-open");                
            $menu.slideDown(150, 'swing', function(){
                var $btn = $menu.siblings("button").first();
                $btn.removeClass(pref+"-plus");
                $btn.addClass(pref+"-minus");
                //$btn.html("-");
                
                if(typeof(callback) == "function"){
                    callback();
                }
            });
        }
        
        function hideMenu($menu, callback){

            if(!$menu.hasClass(pref+"-open")){
                return;
            }
            
            $menu.removeClass(pref+"-open");
            $menu.slideUp(150, 'swing', function(){
                
                var $btn = $menu.siblings("button").first();
                $btn.removeClass(pref+"-minus");
                $btn.addClass(pref+"-plus");
                //$btn.html("+");
                
                if(typeof(callback) == "function"){
                    callback();
                }
            });
            
        }
        
    };
})(jQuery);